<section class="features-area">
    <div class="container">
        <!-- 🔎 Toolbar -->
        <div class="toolbar">
            <div class="search">
                <i class="fas fa-search"></i>
                <input
                    type="text"
                    [formControl]="searchCtrl"
                    placeholder="Buscar opción..."
                />
            </div>

            <div class="count">{{ filtered.length }} opciones</div>
        </div>

        <!-- 🔥 Grid -->
        <div class="grid">
            <div
                class="card"
                *ngFor="let item of filtered; trackBy: trackByTitle"
            >
                <div class="icon" [ngStyle]="{ borderColor: item.color }">
                    <i
                        [class]="item.icon"
                        [ngStyle]="{ color: item.color }"
                    ></i>
                </div>

                <div class="title">
                    {{ item.title }}
                </div>

                <div class="desc">
                    {{ item.desc }}
                </div>

                <a class="btn-ghost" [routerLink]="item.route">
                    Ingresar
                    <i class="fas fa-arrow-right"></i>
                </a>
            </div>
        </div>
    </div>
</section>
